import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  Typography,
  Alert
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  messageDetail?: string;
  icon?: React.ReactNode;
  onClose: () => void;
}

export default function ConfirmationDialog({
  open,
  title,
  message,
  messageDetail,
  icon = <ErrorOutlineIcon sx={{ fontSize: 22, color: 'warning.main' }} />,
  onClose
}: ConfirmationDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden'
        }
      }}>
      <DialogTitle
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          px: 3,
          py: 2.5,
          backgroundColor: 'warning.light'
        }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: 1.5,
              backgroundColor: 'background.paper',
              display: 'flex',
              border: 1,
              borderColor: 'divider'
            }}>
            {icon}
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: 3, py: 3, '& > :first-of-type': { mt: 1 } }}>
        <Alert
          severity="warning"
          variant="outlined"
          sx={{ borderRadius: 2, alignItems: 'flex-start', '& .MuiAlert-message': { width: '100%' } }}>
          <Typography variant="body2" fontWeight={700} sx={{ mb: messageDetail ? 0.75 : 0 }}>
            {message}
          </Typography>
          {messageDetail && (
            <Typography variant="body2" color="text.secondary">
              {messageDetail}
            </Typography>
          )}
        </Alert>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          backgroundColor: 'background.default',
          borderTop: 1,
          borderColor: 'divider'
        }}>
        <Button variant="contained" color="warning" onClick={onClose} sx={{ textTransform: 'none', fontWeight: 600 }}>
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
}
